import { Button, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect, useMemo } from "react";

interface AddNewBingoUserProps {
  otherUsers: string[];
  onUserAdded: (newUser: string) => void;
}

export function AddNewBingoUser({
  otherUsers,
  onUserAdded,
}: AddNewBingoUserProps) {
  const [newUserName, setNewUserName] = React.useState("");
  const [nameIsInErrorState, setNameIsInErrorState] = React.useState(true);

  const errorChecks = useMemo(() => {
    return [
      {
        message: "Name cannot be empty",
        function: (newUserName: string) => newUserName.trim() === "",
      },
      {
        message: "This user already exists",
        function: (newUserName: string) => otherUsers.includes(newUserName),
      },
      {
        message: 'Name cannot be "new"',
        function: (newUserName: string) => newUserName === "new",
      },
      {
        message: "Name cannot be longer than 15 characters",
        function: (newUserName: string) => newUserName.length >= 15,
      },
    ];
  }, [otherUsers]);

  useEffect(() => {
    for (const check of errorChecks) {
      if (check.function(newUserName)) {
        setNameIsInErrorState(true);
        return;
      }
    }
    setNameIsInErrorState(false);
  }, [newUserName, otherUsers, errorChecks]);

  return (
    <Box className="flex flex-col gap-4 p-4 items-center">
      <TextField
        label="Name"
        variant="filled"
        type="search"
        value={newUserName}
        onChange={(e) => setNewUserName(e.target.value.trim().toLowerCase())}
        helperText={
          errorChecks.find((check) => check.function(newUserName))?.message ||
          ""
        }
        error={nameIsInErrorState}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={() => onUserAdded(newUserName)}
        disabled={nameIsInErrorState}
      >
        Create new bingo
      </Button>
    </Box>
  );
}
